import { inputClass, secondaryBtnClass } from "@/components/common/surfaceClasses";
import { SalesConsoleCollapsibleSection } from "./SalesConsoleCollapsibleSection";

type BulkCaptureMsg = { tone: "ok" | "warn"; text: string } | null;

type Props = {
  bulkNotes: string;
  bulkBusy: boolean;
  voiceBusy: boolean;
  voiceHint: string;
  voiceHintTone: "neutral" | "warning";
  bulkError: string;
  bulkCaptureMsg: BulkCaptureMsg;
  onBulkNotesChange: (value: string) => void;
  onToggleVoice: () => void;
  onCaptureLeads: () => void;
};

export function SalesConsoleBulkCaptureSection(props: Props) {
  return (
    <SalesConsoleCollapsibleSection title="Bulk lead capture" subtitle="Paste or dictate multiple leads, then parse into drafts" defaultOpen={false}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex gap-2">
          <button
            type="button"
            onClick={props.onToggleVoice}
            className={`${secondaryBtnClass} px-2.5 py-1 text-xs disabled:opacity-50`}
          >
            {props.voiceBusy ? "Stop listening" : "Speak notes"}
          </button>
          <button
            type="button"
            disabled={props.bulkBusy || !props.bulkNotes.trim()}
            onClick={props.onCaptureLeads}
            className="rounded-lg bg-blue-600 px-2.5 py-1 text-xs font-medium text-white disabled:opacity-50"
          >
            {props.bulkBusy ? "Parsing..." : "Capture Leads"}
          </button>
        </div>
      </div>
      <textarea
        value={props.bulkNotes}
        onChange={(e) => props.onBulkNotesChange(e.target.value)}
        rows={5}
        className={`mt-3 w-full ${inputClass} rounded-xl`}
        placeholder="Paste notes or use Speak notes, then parse."
      />
      {props.bulkCaptureMsg ? (
        <p
          className={`mt-2 text-xs rounded-lg border px-2 py-1.5 ${
            props.bulkCaptureMsg.tone === "ok"
              ? "border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200"
              : "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200"
          }`}
        >
          {props.bulkCaptureMsg.text}
        </p>
      ) : null}
      {props.bulkError ? <p className="mt-2 text-xs text-red-700 dark:text-red-400">{props.bulkError}</p> : null}
      {props.voiceHint ? (
        <p className={`mt-2 text-xs ${props.voiceHintTone === "warning" ? "text-amber-700 dark:text-amber-300" : "text-gray-500 dark:text-zinc-400"}`}>
          {props.voiceHint}
        </p>
      ) : null}
    </SalesConsoleCollapsibleSection>
  );
}
